import { z } from "zod";

export const CancelFreeTrialRequestBodySchema = z.object({
  id: z.string(),
});
export type CancelFreeTrialRequestBodyType = z.infer<
  typeof CancelFreeTrialRequestBodySchema
>;

export const CancelFreeTrialResponseBodySchema = z.object({
  body: z.string(),
});
export type CancelFreeTrialResponseBodyType = z.infer<
  typeof CancelFreeTrialResponseBodySchema
>;
